
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2"}},[_c('path',{attrs:{"d":"M649 137.999h26v18h-14M653 155.999h-4v-14M661 156l-8 6v-6"}})]),_c('path',{attrs:{"d":"M29 3H3a1 1 0 000 2h25v16H15c-.041 0-.076.018-.116.023-.067.008-.13.018-.195.039a.892.892 0 00-.187.089c-.033.019-.071.025-.102.049L8 26v-4a1 1 0 00-1-1H4V8a1 1 0 00-2 0v14a1 1 0 001 1h3v5a1.001 1.001 0 001.6.8l7.733-5.8H29a1 1 0 001-1V4a1 1 0 00-1-1z"}})])
          )
        }
      }
    